import { c as _c } from "react/compiler-runtime";
import noop from 'lodash/noop';
import { useTranslation } from 'react-i18next';
import LinkButton from '../link-button';
import Control from './components/control';
import type { FilterControl, FilterSelectedOption } from './filters.types';
export type FiltersProps = {
  controls: FilterControl[];
  onChange?: (query: string, options: FilterSelectedOption | FilterSelectedOption[]) => void;
  onClear?: () => void;
  ariaLabel?: string;
};
const Filters = t0 => {
  const $ = _c(19);
  const {
    controls,
    onChange: t1,
    onClear: t2,
    ariaLabel
  } = t0;
  const onChange = t1 === undefined ? noop : t1;
  const onClear = t2 === undefined ? noop : t2;
  const {
    t
  } = useTranslation("ui");
  let t3;
  if ($[0] !== controls) {
    t3 = controls.some(_temp);
    $[0] = controls;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const hasSelectedOptions = t3;
  let t4;
  if ($[2] !== ariaLabel || $[3] !== controls || $[4] !== onChange) {
    let t5;
    if ($[6] !== ariaLabel || $[7] !== onChange) {
      t5 = control_0 => <Control control={control_0} disabled={control_0.disabled} key={control_0.query} onChange={onChange} ariaLabel={ariaLabel} />;
      $[6] = ariaLabel;
      $[7] = onChange;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = controls.map(t5);
    $[2] = ariaLabel;
    $[3] = controls;
    $[4] = onChange;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <div className="flex items-center flex-wrap gap-2 justify-start">{t4}</div>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== hasSelectedOptions || $[12] !== onClear || $[13] !== t) {
    t6 = hasSelectedOptions && <div className="h-8 flex flex-col justify-center whitespace-nowrap"><LinkButton onClick={onClear}>{t("components.filters.clear-filters") as string}</LinkButton></div>;
    $[11] = hasSelectedOptions;
    $[12] = onClear;
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== ariaLabel || $[16] !== t5 || $[17] !== t6) {
    t7 = <div className="relative flex items-start justify-between gap-3" aria-label={ariaLabel}>{t5}{t6}</div>;
    $[15] = ariaLabel;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
export default Filters;
function _temp(control) {
  return control.selectedOptions && control.selectedOptions.length > 0;
}